import React from 'react'
// import styles from './ProtectedRoute.module.css';


export default function ProtectedRoute(props) {
 
    return <>{props.children}</>
  
}